<template>
   <v-container>
      <v-sheet outlined>
         <v-tabs height="40" v-model="admintab" :slider-color="$globalstore.tab_slidercolor">
            <v-tab href="#today">Today</v-tab>
            <v-tab href="#group">Groups</v-tab>
         </v-tabs>
         <v-tabs-items v-model="admintab">
            <v-tab-item :key="1" value="today">
               <v-data-table
                  dense
                  :caption="agendacaption"
                  hide-default-footer
                  :headers="agenda_header"
                  :items="todaylist"
                  item-key="event_id"
                  single-select
                  @click:row="agendaRowClick"
               >
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.actions="{item}">
                     <v-btn small color="primary" @click="takeAttendance(item)">
                        <v-icon>mdi-account-outline</v-icon>
                     </v-btn>
                  </template>
               </v-data-table>
            </v-tab-item>
            <v-tab-item :key="2" value="group">
               <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="4" class="px-3">
                     <v-select
                        v-model="termyearselect"
                        :items="termyear"
                        item-text="termyeartext"
                        item-value="id"
                        label="Select Term/Year"
                        return-object
                        @change="changeTerm"
                     >
                     </v-select>
                  </v-col>
               </v-row>
               <v-data-table
                  dense
                  caption="Assigned Groups"
                  :headers="group_header"
                  :items="grouplist"
                  item-key="cca_id"
                  @click:row="grouplistRowClick"
                  single-select
               >
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.cca_description="{item}">
                     {{ item.cca_description | ellipsetext(50) }}
                  </template>
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.actions="{item}">
                     <v-icon @click="viewGroup(item)">mdi-eye-outline</v-icon>
                  </template>
               </v-data-table>
            </v-tab-item>
         </v-tabs-items>
      </v-sheet>
   </v-container>
</template>

<script>
   import StaffAttendance from "@/components/StaffAttendance.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         StaffAttendance,
      },

      data() {
         return {
            admintab: "today",
            savetab: "",
            grouplist: [],
            todaylist: [],
            termyearselect: null,
            termyear: [],
            agenda_header: [
               {
                  text: "Time",
                  value: "startend",
                  width: "30px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Group",
                  value: "cca_name",
                  width: "150px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Description",
                  value: "event_description",
                  width: "150px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  width: "120px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "120px",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
            group_header: [
               {
                  text: "Name",
                  value: "cca_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Description",
                  value: "cca_description",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Day/Time",
                  value: "daytime",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Sub",
                  value: "participantcount",
                  align: "end",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Wait",
                  value: "waitlistcount",
                  align: "end",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Max",
                  value: "max_participant",
                  align: "end",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "",
                  value: "actions",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
         };
      },
      computed: {
         agendacaption() {
            return "Agenda For Today (" + new Date().toISOString().substr(0, 10) + ")";
         },
      },
      methods: {
         onTabChange(tab) {
            this.savetab = tab;
         },

         agendaRowClick(item, row) {
            row.select(!row.isSelected);
         },
         grouplistRowClick(item, row) {
            row.select(!row.isSelected);
         },

         takeAttendance(item) {
            this.$router.push({
               name: "StaffAttendance",
               params: {event: item},
            });
         },

         viewGroup(item) {
            this.$router.push({
               name: "ViewGroup",
               params: {groupid: item.cca_id},
            });
         },

         changeTerm() {
            this.loadStaffGroupList();
         },

         async loadStaffGroupList() {
            await this.$http({
               url: "/cca/getallgroup_byadminid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  year: this.termyearselect.year,
                  term: this.termyearselect.term,
                  admin_id: this.$globalstore.user.userid,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.grouplist = response.data.groupdata;
                  }
               }
            });
         },
         async loadTodayEventList() {
            await this.$http({
               url: "/cca/admintodaylist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.todaylist = response.data.todaylist;
                  }
               }
            });
         },
         SetTermYear() {
            if (this.termyear.length > 0) {
               if (this.$globalstore.currentyear && this.$globalstore.currentterm) {
                  this.termyearselect = this.termyear.find(
                     (x) =>
                        x.year == this.$globalstore.currentyear &&
                        x.term == this.$globalstore.currentterm
                  );
               } else {
                  this.termyearselect = this.termyear.find(
                     (x) => x.id == this.$globalstore.appsettings.currentyearterm.id
                  );
               }
            }
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.termyear = this.$globalstore.termyearlist;
            this.SetTermYear();

            this.loadStaffGroupList();
            this.loadTodayEventList();
            if (this.savetab) {
               this.admintab = this.savetab;
            }
         }
      },
   };
</script>
